import React from 'react';
import { LinearProgress } from '@mui/material';
import "./Loader.css";

const Loader = ({ loading }) => {
 
  if(loading){
    document.body.style.overflow = 'hidden';
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }else{
    document.body.style.overflow = 'auto';
  }
  
  if (!loading) return null;


  return (
    
      <div className="loader-container">
        <LinearProgress color="inherit" />
      </div>
  );
};

export default Loader;